import { render, staticRenderFns } from "./activeLrsList.vue?vue&type=template&id=2a8c26cc&"
import script from "./activeLrsList.vue?vue&type=script&lang=js&"
export * from "./activeLrsList.vue?vue&type=script&lang=js&"
import style1 from "./activeLrsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports